<div class="form-check-inline switchery-primary m-0 pe-2">
    <label *ngIf="label" [for]="label" class="ps-1 me-1">
        {{ label }}
        <i *ngIf="tooltip" class="bi bi-info-circle text-primary ms-1" [ngbTooltip]="tooltip" placement="top"></i>
    </label>
    <ui-switch [id]="label" class="switchery align-bottom float-end pt-1" size="small" [checked]="localItem"
        (change)="onSwitchChange($event)" [disabled]="disable">
    </ui-switch>
    <label *ngIf="trueValue" [for]="trueValue" [ngClass]="localItem ? '' : 'disabled-class'" class="pt-1 ps-1">
        {{ localItem ? trueValue : falseValue }}
    </label>
</div>